import React from "react";
import NoTableData from '../../../../componets/Dashboard/Driveanalysis/NoTableData';

function Table_Orion(props) {
  let { data, head, post_fix } = props;

  function isFloat(n) {
    return n === +n && n !== (n | 0);
  }

  return (
    <>
      <table className="table table-striped fixed_header" style={{ overflowY: 'scroll' }}>
        <thead style={{ fontWeight: "bold", backgroundColor: '#CDDAEA', color: '#222', fontWeight: 'normal', fontSize: '0.825em', borderBottom: '1px solid #358696' }}>
          <tr>
            <th scope="col" className="cols" style={{ float: "left" }} >{head.head1}</th>
            <th scope="col">{head.head2}</th>
          </tr>
        </thead>
        <tbody>

          {(data.length == 0) ? <NoTableData /> : data.map(x => {
            return (<tr key={x.key}>
              <td scope="row " className="hand_geture" style={{ float: "left", fontSize: "1em" }} onClick={() => props.singleVinSelected(x.key)}>{x.key}</td>
              {isFloat(x.occ) ?
                (<td style={{ fontSize: "1em" }}>{x.occ.toFixed(0)}</td>)
                : (<td style={{ fontSize: "1em" }}>{x.occ}</td>)
              }
            </tr>)
          })}
        </tbody>
      </table>
    </>
  );
}

export default Table_Orion;